import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { API_URL } from '../../../config';



const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));

const EditDevice5 = ({ deviceid,editdeviceToggleModal,successeditdeviceToggleModal,godevicelist,devicekeyToggleModal }) => {

    const classes = useStyles();

    const [editdata, setEditdata] = useState([]);

    const [checkboxshow, setCheckboxshow] = useState(false)
    const [cmoduleval, setCmoduleval] = useState(0)
    const [mmoduleval, setMmoduleval] = useState(0)
    const [errorMessege, setErrorMessege] = useState(false);
    const [devicetype, setDevicetype] = useState(0)
    const [checkingboxmessge, setCheckingboxmessge] = useState(false);
    const [GoPersonaldefaultdata, setGoPersonaldefaultdata] = useState(5)
    const [editserialkey, setEditserialkey] = useState('');



    useEffect(() => {
        getgodevicebyid()


    }, [])



    const HandleEditdeviceType = (e)=>{
        
        var val = e.target.value
        setDevicetype(e.target.value);

        setGoPersonaldefaultdata(6)
        
        if (val == "null") {
            setErrorMessege(true)
        } else {
            setErrorMessege(false)
        }

        setCmoduleval(0)
        setMmoduleval(0)

       

        if (val == 5) {
            setCheckboxshow(true)
            setCheckingboxmessge(true)
        } else {
            setCheckboxshow(false)
            setCheckingboxmessge(false)
           
        }
    }


    const HandleCmodule = (e) => {

        if (e.target.checked) {
            setCmoduleval(1)
        } else {
            setCmoduleval(0)
        }
    }

    const HandlemModule = (e) => {
        if (e.target.checked) {
            setMmoduleval(1)
        } else {
            setMmoduleval(0)
        }
    }


    const getgodevicebyid = () => {


        fetch(API_URL + "/get/personal/device/by/" + deviceid,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    resp.data.map((item)=>{
                        setEditserialkey(item.serial_key.replace("P6.0-",""))
                    })
                    setEditdata(resp.data[0]) 
                    setDevicetype(resp.data[0].device_type)
                    setCmoduleval(resp.data[0].c_module)
                    setMmoduleval(resp.data[0].m_module)
                   
                    
                });
            }



        })
    }


    const editDevice = () => {
        let data = {};

        if (editserialkey.trim().length == 0) {
            setErrorMessege(true)
            return false;
        }else{
            data['serial_key'] = editserialkey?.replace("P5.0-","");
            // data['device_type'] = devicetype;
            data['c_module'] = cmoduleval;
            data['m_module'] = mmoduleval;
        }
            fetch(API_URL + "/update/personal/device/" + deviceid, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
    
                },
                body: JSON.stringify(data)
            }).then((response) => {
    
                if (response.status == 200) {
                    response.json().then((resp) => {
                        editdeviceToggleModal()
                        successeditdeviceToggleModal()
                        godevicelist()
                        // window.location.reload
                        // location.reload(true);
                        // const interval = setInterval(() => {
                        //     location.reload("/")
    
                        // }, 3000);
                        // return () => clearInterval(interval);
                    });
                } else if (response.status == 400) {
                    devicekeyToggleModal();
                }
                else {
                    alert("network error")
                }
    
            })
        

      

    }

const HandleEditSerialkey = (event) =>{
    setEditserialkey(event);
}


    return (
        <div>
            <ul className='deviceformlist'>
                <li>

                    <div className="input-group mb-3 device-input">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">P5.0-</span>
                        </div>
                        {/* <input placeholder='Write serial key' defaultValue={editdata?.serial_key?.replace("P5.0-","")}  onChange={(e)=>HandleEditSerialkey(e.target.value)} /> */}
                        <input placeholder='Write serial key' value={editserialkey?.replace("P5.0-","")}  onChange={(e)=>HandleEditSerialkey(e.target.value)} />
                    </div>
                    {/* <div className='select-device-type'>
                                    <select onChange={HandleEditdeviceType}>
                                        <option value="null">Select device type</option>
                                        <option selected={5 == editdata?.device_type? true : false} value="5">GO Personal</option>
                                        <option selected={6 == editdata?.device_type? true : false} value="6">GO Basic</option>
                                        <option selected={7 == editdata?.device_type? true : false} value="7">GO Professional</option>
                                    </select>

                                    {
                                         devicetype == 5 && <div className='wrp-checkbox-module'><input type="checkbox" onChange={HandleCmodule}  defaultChecked={1 == editdata?.c_module?true : false} /><label className='c_module'>C module</label> <input type="checkbox" defaultChecked={1 == editdata?.m_module?true : false} onChange={HandlemModule} className='mrl-module' /> <label>M module</label></div>
                                    }
 
                                    {
                                        ( devicetype == 5 && cmoduleval == 1 && mmoduleval == 1) &&<p>Please note that checking off C-module and M-module checkboxes together will make this a Go Basic device.</p>
                                    }

                                    
                                </div>
                                */}
                    {
                        errorMessege && <p className='error-message'>Required field</p>
                    }

                </li>

                <li>
                    <div className='addBtn'>
                        <button onClick={editDevice}>Update</button>
                    </div>
                </li>

            </ul>
        </div>
    )
}

export default EditDevice5;